import { render, staticRenderFns } from "./veStuCaucusEdit.vue?vue&type=template&id=8ca9cb34&scoped=true"
import script from "./veStuCaucusEdit.vue?vue&type=script&lang=js"
export * from "./veStuCaucusEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca9cb34",
  null
  
)

export default component.exports